import { UserException } from '@/domain/user/exception/UserException'

export class CannotResetPasswordUserException extends UserException {

}
